import React, {useEffect, useState} from 'react'
import { TableWrapper } from '../../../libs/react-mpk/wrapper'
import Modal from '../../../libs/react-mpk/components/Modal'
import t from 'counterpart'
import service from './PengenaanPajakLainnya.service'
import moment from 'moment'
import { toast } from '../../../libs/react-mpk/services'

const PengenaanPajakLainnyaTable = ({
  className       = '',
  showCommandbar  = true,
  history
}) => {

  const [confirmDelete, setConfirmDelete] = useState(false)
  const [confirmDeleteData, setConfirmDeleteData] = useState({})

  function _closeConfirmDelete() {
    setConfirmDelete(false)
  }
  async function _submitConfirmDelete(callback) {
    var r = await service.delete(confirmDeleteData.id)
    toast.info(`Data ${confirmDeleteData.nama} telah di hapus.`); callback()
    setConfirmDelete(false)
  }

  return (
    <>
    <TableWrapper
      baseId="mod-table-sample"
      title={t.translate('modules.pengenaanPajakLainnya.title')}
      className={className}
      // hintMessage={t.translate('modules.table.hint.message')}
      hintIconClassName="mdi mdi-information"
      hintMore={t.translate('modules.table.hint.more')}
      defaultData={[]}
      defaultSortBy="kodeKop"
      columns={[
        {
          label: 'Kode KOP',
          searchable: true,
          key: 'kodeKop',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.kodeKop)
        },{
          label: 'Nama KOP',
          searchable: true,
          key: 'namaKop',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.keterangan)
        },{
          label: 'Keterangan',
          searchable: true,
          key: 'keterangan',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.keterangan)
        },{
          label: 'Dasar Hukum',
          searchable: true,
          key: 'dasarHukum',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.nama)
        },{
          label: 'Kategori PPh',
          searchable: true,
          key: 'kategoriPPh',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.kategoriPPh)
        },{
          label: 'Jenis Penghasilan',
          searchable: true,
          key: 'jenisPenghasilan',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.jenisPenghasilan)
        },{
          label: 'Tarif',
          searchable: true,
          key: 'tarif',
          type: TableWrapper.dataTypes.STRING,
          render: item => (item.tarif)
        }
      ]}
      actions={[
        new TableWrapper.action('Add', 'mdi mdi-plus', () => history.push('/onpremise/pengenaan-pajak-lainnya/baru'), true)
      ]}
      itemActions={[
        new TableWrapper.action('Edit', 'mdi mdi-pencil', (item) => history.push(`/onpremise/pengenaan-pajak-lainnya/${item.id}`), true),
        new TableWrapper.action('Delete', 'mdi mdi-delete', (item) => { setConfirmDeleteData(item); setConfirmDelete(true)}, true)
      ]}
      onFetchData={ async query => {
        return service.get(query)
      }}
      showCommandbar={showCommandbar}
      showFilterPeriod={false}
    />
    <Modal.Confirm
      // title="Hapus Data"
      visible={confirmDelete}
      onRequestClose={_closeConfirmDelete}
      onSubmit={_submitConfirmDelete}
    >Hapus data {confirmDeleteData.nama}?</Modal.Confirm>
    </>
  )
}

export default PengenaanPajakLainnyaTable
